import React from 'react';
import { Segment, Form, Button, Table, Loader, Popup } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { HeaderCursor } from '../../Professor/ProfessorInputGrades/css';

export default class StudentFilterForSPEnroll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            jmbg: '',

            students: [],

            loading: false,
            open: false
        };

        this.showStudents = this.showStudents.bind(this);
    }

    showStudents() {
        const { firstName, lastName, jmbg } = this.state;
        if (!firstName && !lastName && !jmbg) {
            toast('Morate unijeti bar jedan filter.');
        } else {
            this.setState({ loading: true });

            let docFilter = {};

            if (firstName) docFilter = { ...docFilter, firstName };
            if (lastName) docFilter = { ...docFilter, lastName };
            if (jmbg) docFilter = { ...docFilter, jmbg };

            axios.post('students/filter-all/', { ...docFilter })
                .then(res => {
                    this.setState({ students: res.data, open: true, loading: false });
                })
                .catch(err => {
                    console.log('Failed to fetch students');
                });
        }
    }

    render() {
        return (
            <div >
                <h1>Upis na studijski program</h1>
                <Segment.Group raised>
                    <Segment>
                        <h3>Studenti</h3>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Ime</label>
                                    <input
                                        value={this.state.firstName}
                                        onChange={(e) => this.setState({ firstName: e.target.value })}
                                        name="firstName"
                                        placeholder="Unesite ime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Prezime</label>
                                    <input
                                        value={this.state.lastName}
                                        onChange={(e) => this.setState({ lastName: e.target.value })}
                                        name="lastName"
                                        placeholder="Unesite prezime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>JMBG</label>
                                    <input
                                        value={this.state.jmbg}
                                        onChange={(e) => this.setState({ jmbg: e.target.value })}
                                        name="jmbg"
                                        placeholder="Unesite jmbg"
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Button floated="right" color="blue" onClick={this.showStudents}>Prikaži studente</Button>
                        </Form>
                        <br/>

                        <ToastContainer hideProgressBar />

                    {(this.state.open || this.state.loading) &&
                        <div>
                            <br/>
                            {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                                : this.state.students.length ?
                                    <Table celled selectable compact >
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>Prezime i ime</Table.HeaderCell>
                                                <Table.HeaderCell>Ime oca</Table.HeaderCell>
                                                <Table.HeaderCell>JMBG</Table.HeaderCell>
                                                <Table.HeaderCell>OID</Table.HeaderCell>
                                                <Table.HeaderCell width="2" />
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body> {this.state.students.map((el, index) =>
                                            (
                                                <Table.Row key={index}>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.lastName} {el.firstName}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.father ? el.father.firstName : null}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.jmbg}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.oid}
                                                    </Table.Cell>
                                                    <Table.Cell textAlign="center" verticalAlign="middle" width="2">
                                                        <Link to={{
                                                            pathname: '/upis-studenata/upis-na-studijski program',
                                                            state: { student: el, withoutSP: true }
                                                        }}
                                                        >
                                                            <Popup
                                                                content="Odabir studijskog programa"
                                                                position="top center"
                                                                trigger={
                                                                    <Button
                                                                        basic="true"
                                                                        color="blue"
                                                                        circular
                                                                        icon="list"
                                                                        size="small"
                                                                    >
                                                                    </Button>}
                                                            >
                                                            </Popup>
                                                        </Link>
                                                    </Table.Cell>
                                                </Table.Row>
                                            ))}
                                        </Table.Body>
                                    </Table>
                                    : 'Nema studenata.' }
                        </div>}
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentFilterForSPEnroll.js